import { useState } from "react";
import { toast } from "react-toastify";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, H6, P } from "../../../../../AbstractElements";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import { CopyHighlightedText, CopyPortionParagraphTitle } from "../../../../../Utils/Constants";

export default function CopyPortionFromParagraph() {
  const [highlightTextValue, setHighlightTextValue] = useState("Web design is the process of creating websites");
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(highlightTextValue);
      setHighlightTextValue(highlightTextValue);

      setTimeout(() => {
        setHighlightTextValue(highlightTextValue);
      }, 2000);
    } catch (err) {
      toast.error("Failed to copy text: " + err);
    }
  };
  return (
    <Col sm={12} md={6}>
      <Card>
        <CommonCardHeader title={CopyPortionParagraphTitle} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="card-description mb-2">{"Copy portion from paragraph"}</P>
            <H6 className="border rounded f-w-300">
              <CardBody>
                <span className="bg-primary text-white p-1">{"Web design is the process of creating websites "}</span>
                {" that are visible online. Take a website design course to learn how to  create an appealing and responsive website. In the discipline of web design, there are degree, diploma, postgraduate degree, and certificate programmes. A web designer is responsible for a website's look, feel, and occasionally even content."}
              </CardBody>
            </H6>
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard text-ligth" color="secondary" onClick={handleCopy}>
                <i className="fa-solid fa-copy" /> {CopyHighlightedText}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
